// Any plugins you want to use has to be imported
// Detail menu config list see https://www.tiny.cloud/docs/tinymce/latest/menus-configuration-options/

const menubar = 'file edit view insert format tools table';

export default menubar;
